<template>
	<el-dialog v-model="innerVisible" :title="title" width="92%" custom-class="zero-padding-modal" @open="openInit" @opened="openedInit" @closed="closeDeal">
		<template #default>			
			<div class="assemble-edit-modal-content">
				<el-form :model="addForm" label-width="130px" ref="dialogRef" :rules="formRules" style="padding-top: 20px;">
					<el-row>		
						<el-col :span="6">
							<el-form-item label="转入仓库:" prop="transferToReceipt">
								<el-input v-model="addForm.transferToReceipt" clearable placeholder="请输入转入仓库" />
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="转入库位:" prop="transferredILocation">
								<el-input v-model="addForm.transferredILocation" clearable placeholder="请输入转入库位" />
							</el-form-item>
						</el-col>                                 
					</el-row>
				</el-form>
				<div class="modal-content-top">
					<el-button type="primary" icon="el-icon-plus" @click="onOpenChooseModal">添加物料</el-button>
				</div>				
				<div class="modal-content-list">
					<div class="list-padding">
						<el-table :data="list" border row-key="tableKey">
							<el-table-column label="序号" align="center" width="60">
								<template #default="scope">{{scope.$index+1}}</template>
							</el-table-column>
							<el-table-column label="项目编号" prop="projectCode" align="center" width=""/>
							<el-table-column label="品号" prop="code" align="center" width=""/>
							<el-table-column label="品名" prop="name" align="center" width="250"/>
							<el-table-column label="规格型号" prop="specificationModel" align="center" width="350"/>
							<el-table-column label="单位" prop="unit" align="center" width="60"/>							
							<el-table-column label="容器编号" prop="containerCode" align="center" width=""/>
							<el-table-column label="库位编号" prop="locationCode" align="center" width=""/>
							<el-table-column label="库位状态" align="center" width="">
							  <template #default="scope">
							    <span>{{ localStatus(scope.row.locationStatus) }}</span>
							  </template>
							</el-table-column>
							<el-table-column label="库存数" prop="currentQuantity" align="center" width=""/>
							<el-table-column label="出库数" width="" align="center">
							  <template #default="scope">
									<el-input-number v-model="scope.row.orderQuantity" :min="1" :max="scope.row.currentQuantity" size="small" />
							  </template>
							</el-table-column>
							<el-table-column label="操作" width="80" align="center">
							  <template #default="scope">
							    <el-button type="danger" size="small" @click="onDel(scope.$index)">删除</el-button>
							  </template>
							</el-table-column>
						</el-table>
					</div>
				</div>				
			</div>			
			<choose-material-modal v-model:visible="chooseVisieble" @callback="chooseModalCallback"  />
		</template>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="onBtnClose">取 消</el-button>
				<el-button type="primary" :disabled="list.length===0" @click="confirm">提 交</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { defineEmits, ref, watch, toRefs,reactive } from 'vue'	
import ChooseMaterialModal from './ChooseMaterialModal.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { AddTransferOrderDetails } from '@/service/main/invoices/allocateOrder';
import { localStatus } from '../../switchCase'

const emits = defineEmits(['update:visible','loadInitData','callback'])

const props = defineProps({
	visible:{
		type:Boolean,
		default:false
	},
	type:{
		type:String,
		default:'info'
	},
	orderId:{
		type:[String,Number],
		default:''
	}
})
//////////////////////////////////
const formRules = {
    transferToReceipt: [{ required: true, message: "发货地不能为空", trigger: "blur" }],
    transferredILocation: [{ required: true, message: "收货地址不能为空", trigger: "blur" }],
}
const addForm = reactive({
    id: 0,
	transferToReceipt:"",//单别
    transferredILocation: "",//部门编号
})
const { visible, type, orderId } = toRefs(props)

const innerVisible = ref(false)
const title = ref('单据明细新增')
const chooseVisieble = ref(false)
const list = ref([])

watch(
	visible,
	function(newVal){
		if (innerVisible.value!==newVal) {
			innerVisible.value = newVal
		}
	},
	{immediate:true}
)
watch(innerVisible,function(newVal){
	if (visible.value!==newVal) {
		emits('update:visible',newVal)
	}
})

const closeDeal = function(){
	list.value = []
}

const onBtnClose = function(){
	selfClose()
}

const selfClose = function(){
	innerVisible.value = false
	addForm.transferToReceipt= ""//项目编号
    addForm.transferredILocation = ""
}

const checkBeforeSubmit = function() {
	let n = -1
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].orderQuantity<=0) {
			n = i;
			break
		}
	} 
	if (n===-1) {
		return true
	} else {
		ElMessageBox.alert(`第${n+1}笔物料出库数错误。`,'系统提示')
		return false
	}
}
const dialogRef = ref()
const confirm = function(){
	dialogRef.value.validate((valid) => {
        if (valid) {
            // let f = checkBeforeSubmit()
			// if (!f) return flase
			let para = {
				transferOrderDetailsList:list.value,
				transferToReceipt:addForm.transferToReceipt,
				transferredILocation:addForm.transferredILocation,
				id:orderId.value
			}
			// console.log('params',para)
			AddTransferOrderDetails(para).then((res) => {
				ElMessage.success("操作成功")
				selfClose()
				emits('callback')
			}).catch(()=>{
				// callback && callback(false)
			})
			// confirmAjax((f)=>{
			// 	if (f) {
			// 		ElMessage.success("操作成功")
			// 		selfClose()
			// 		emits('callback')
			// 	}
			// })
        } 
    })
	
}

const openInit = function(){
	console.log('addForm',)
}

const openedInit = function(){
	// if (type.value==='modify') {
		getModifyInitData()
	// }
}

const getModifyInitData = function(){
	emits('loadInitData',{id:orderId.value,PageNo:1,PageSize:9999},function(f,d){
		if (f) {
			list.value = (d.data.rows || []).map((obj,index)=>{
				obj.tableKey = 'edit-' + new Date().getTime() + '-' + index
				return obj
			})
		}
	})
}

// const setTitle = function(){
// 	if (type.value==='modify') {
// 		title.value = '修改调拨单'
// 	} else {
// 		title.value = '新增调拨单'
// 	}
// }

const onOpenChooseModal = function(){
	chooseVisieble.value = true
}

const chooseModalCallback = function(arr){
	if (list.value.length===0) {
		list.value = arr.map((obj,index)=>{
			obj.tableKey = 'add-' + new Date().getTime() + '-' + index
			obj.orderQuantity = obj.currentQuantity
			return obj
		})
	} else {
		addChooseMaterials(arr)
	}
}

const addChooseMaterials = function(arr) {
	let c = 0
	arr.forEach((arritem,arri)=>{
		if (checkMaterialExist(arritem)) {
			c++
		} else {
			arritem.tableKey = 'add-' + new Date().getTime() + '-' + arri
			arritem.orderQuantity = arritem.currentQuantity
			list.value.push(arritem)
		}
	})
	
	if (c>0) {
		ElMessageBox.alert(`有${c}哥物料已存在，未加入。`,'系统提示')
	}
}

const checkMaterialExist = function(obj) {
	let res = false
	for (let i=0;i<list.value.length;i++) {
		if (list.value[i].code===obj.code && list.value[i].locationCode===obj.locationCode) {
			res = true
			break
		}
	}
	return res
}

const onDel = function(index) {
	list.value.splice(index,1)
}

const confirmAjax = function(callback){
	// modifyAjax(callback)	
	
}

const modifyAjax = function(callback) {
	let params = {
		transferOrderDetailsList:list.value,
		transferToReceipt:addForm.value.transferToReceipt,
		transferredILocation:addForm.value.transferredILocation,
		id:orderId.value
	}
	console.log('params',params)
	// AddTransferOrderDetails(params).then((res) => {
	//   callback && callback(true)
	// }).catch(()=>{
	// 	callback && callback(false)
	// })
}

</script>

<style lang="less" scoped>
.assemble-edit-modal-content{
	height: 60vh;
	display: flex;
	flex-direction: column;
	.modal-content-top {
		padding: 12px 16px;
		flex-shrink: 0;
	}
	.modal-content-list{
		flex-grow: 1;
		height: 1px;
		overflow: auto;
		.list-padding{
			padding: 0 16px;
		}
	}
}
</style>